import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TenantService } from '../services/tenant.service';

function resolveTenantId(tenantService: TenantService): string {
  try {
    const tenantId = tenantService.getTenantId();
    if (tenantId) {
      return tenantId;
    }
  } catch {
    // ignore
  }

  const tenantConfig = (window as any).__tenantConfig as { tenantId?: string } | undefined;
  if (tenantConfig?.tenantId) {
    return tenantConfig.tenantId;
  }

  return environment.tenantId || 'platform';
}

export const tenantIdInterceptor: HttpInterceptorFn = (req, next) => {
  const baseApiUrl = typeof environment.baseApiUrl === 'string'
    ? environment.baseApiUrl
    : String(environment.baseApiUrl || '');

  const requestUrl = req.url;
  const isBackendRequest = baseApiUrl && requestUrl.startsWith(baseApiUrl);

  if (!isBackendRequest) {
    return next(req);
  }

  if (req.headers.has('x-tenant-id') || req.headers.has('X-Tenant-Id')) {
    return next(req);
  }

  const tenantService = inject(TenantService);
  const tenantId = resolveTenantId(tenantService);

  return next(
    req.clone({
      setHeaders: {
        'X-Tenant-Id': tenantId,
      },
    })
  );
};
